import { v4 as uuidv4 } from "uuid";

export class Document {
  documentId: string | undefined;
  referenceId: string | undefined;

  documentTitle: string | undefined;

  s3Key: string | undefined;
  folderName: string | undefined;
  folderId: string | undefined;

  active: boolean = true;
  createdAt: string | undefined;
  createdBy: string | undefined;
  modifiedAt: string | undefined;
  modifiedBy: string | undefined;
}

export enum ReferenceType {
  BUSINESS_HOME = "home",
  CAREGIVER = "caregiver",
  RESIDENT = "resident",
  USER = "user",
  USER_TO_USER = "userToUser"
}

export function convertFileToDocument(
  file: File,
  referenceId: string,
  referenceType: string,
  folderName: string,
  folderId: string,
) {
  var document: Document = new Document();
  const uniqueId = uuidv4();

  document.active = true;
  document.referenceId = referenceId;
  document.documentId = uniqueId;
  document.documentTitle = file.name;
  document.s3Key = `${referenceType}/${referenceId}/${uniqueId}`;
  document.folderName = folderName;
  document.folderId = folderId;

  return document;
}

export class DocumentFolder {
  folderId: string | undefined;
  referenceId: string | undefined;
  folderName: string | undefined;

  createdAt: string | undefined;
  createdBy: string | undefined;
}

export class SharedFolder {
  folderId: string | undefined;
  id?: string | undefined;
  sharedUserId: string | undefined;

  createdAt?: string | undefined;
  createdBy?: string | undefined;
  ttl?: number | undefined;

  folderName?: string | undefined;
  folderOwner?: string | undefined;
}